if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const applyCartSection = (text) => {
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();

				document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
				});
				document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
				});

				if ( alert !== null ) {
					this.form.prepend(alert);
				} 

				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
						
				const event = new Event('cart-updated');
				this.dispatchEvent(event);
			};

			const finish = () => {
				this.form.classList.remove('processing');
				try {
					termsAndCondition();
				} catch (error) {}
			};

			// When removing the main product, also remove linked Rebuy Product Add-Ons
			if ( newQty === 0 ) {
				const itemKey = item.dataset.id;
				const cartUrl = (window.Shopify && Shopify.routes && Shopify.routes.root)
					? `${Shopify.routes.root}cart.js`
					: '/cart.js';
				const updateUrl = (window.Shopify && Shopify.routes && Shopify.routes.root)
					? `${Shopify.routes.root}cart/update.js`
					: '/cart/update.js';

				fetch(cartUrl)
					.then(response => response.json())
					.then(cart => {
						const lineItem = (cart.items || []).find(i => i.key === itemKey);
						const updates = {};
						updates[itemKey] = 0;

						const isAddon = typeof window.isRebuyAddonLineItem === 'function'
							? window.isRebuyAddonLineItem
							: (li) => {
									const props = li.properties || {};
									const source = props._source || '';
									const attribution = String(props._attribution || '').toLowerCase();
									return source === 'Rebuy' || attribution.indexOf('rebuy') !== -1;
								};

						// Only remove add-ons that were linked to THIS parent product.
						// Do not remove add-ons belonging to a different product in the cart.
						if ( lineItem && ! isAddon(lineItem) ) {
							const linkedAddonVariants = typeof window.getRebuyAddonsForParent === 'function'
								? window.getRebuyAddonsForParent(lineItem.variant_id)
								: [];

							if ( linkedAddonVariants.length ) {
								const linkedSet = {};
								linkedAddonVariants.forEach(id => { linkedSet[Number(id)] = true; });

								(cart.items || []).forEach(li => {
									if (
										li.key !== itemKey &&
										isAddon(li) &&
										linkedSet[Number(li.variant_id)]
									) {
										updates[li.key] = 0;
									}
								});
							}

							if ( typeof window.clearRebuyAddonLinksForParent === 'function' ) {
								window.clearRebuyAddonLinksForParent(lineItem.variant_id);
							}
						} else if ( lineItem && isAddon(lineItem) && typeof window.unlinkRebuyAddonVariant === 'function' ) {
							window.unlinkRebuyAddonVariant(lineItem.variant_id);
						}

						return fetch(updateUrl, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
							body: JSON.stringify({ updates })
						});
					})
					.then(() => fetch('?section_id=helper-cart'))
					.then(response => response.text())
					.then(applyCartSection)
					.catch(e => {
						console.log(e);
						let err = document.createElement('span');
						err.classList.add('alert', 'alert--error');
						err.textContent = KROWN.settings.locales.cart_general_error;
						this.form.prepend(err);
					})
					.finally(finish);

				return;
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(applyCartSection)
				.catch(e => {
					console.log(e);
					let err = document.createElement('span');
					err.classList.add('alert', 'alert--error');
					err.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(err);
				})
				.finally(finish);
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}
}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = (options = {}) => {
		// Default: do not open the drawer (callers must pass open: true explicitly)
		const openSidebar = options.open === true;
		let renderToken = window.__cartRenderToken || 0;
		if ( ! options.preserveToken ) {
			window.__cartRenderToken = renderToken + 1;
			renderToken = window.__cartRenderToken;
		}

		return fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {
			// Drop stale responses so an older fetch cannot overwrite newer cart HTML
			if ( ! options.preserveToken && renderToken !== window.__cartRenderToken ) return;

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormEl = sectionInnerHTML.getElementById('AjaxCartForm');
			const cartSubtotalEl = sectionInnerHTML.getElementById('AjaxCartSubtotal');
			const cartItems = document.getElementById('AjaxCartForm');

			if ( ! cartFormEl || ! cartItems ) return;

			cartItems.innerHTML = cartFormEl.innerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				const count = cartItems.querySelector('[data-cart-count]');
				if ( count ) elm.textContent = count.textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
				const total = cartItems.querySelector('[data-cart-total]');
				if ( total ) elm.textContent = total.textContent;
			});

			if ( cartSubtotalEl && document.getElementById('AjaxCartSubtotal') ) {
				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalEl.innerHTML;
			}

			if ( openSidebar && document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		});

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {
				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');

				this.loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add('processing');
						if (this.discountCodes) {
							this.discountCodes.classList.add('processing');
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.handleSuccess();
									} else {
										this.handleError();
									}
								} else {
									this.handleError();
								}
							})
							.catch(error => {
								this.handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			handleSuccess(){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
						this.cartSubtotal.innerHTML = cartSubtotalInnerHTML;
						this.cartSubtotal.classList.remove('processing');
						this.cartDiscountError.innerHTML = '';
						if ( sectionInnerHTML.querySelector('[data-js-discount-codes]') ) {
							this.discountCodes.innerHTML = sectionInnerHTML.querySelector('[data-js-discount-codes]').innerHTML;
							this.discountCodes.classList.remove('processing');
							this.loadDiscountButtons();
						}
						this.input.value = '';
					})
			}

			loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains('enabled') ) {
						elm.classList.add('enabled');
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add('processing');
							if (this.discountCodes) {
								this.discountCodes.classList.add('processing');
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			handleError(){
				this.cartSubtotal.classList.remove('processing');
				if (this.discountCodes) {
					this.discountCodes.classList.remove('processing');
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}